// extracted by mini-css-extract-plugin
export default {"container":"DeleteFileModal_container__z2aLy","warning-icon":"DeleteFileModal_warning-icon__r0iXC","title":"DeleteFileModal_title__gigNW"};